export default {
  id: "customTotalRevenue",
  name: "",
  description: "",
  report: {
    name: "Total Revenue",
    chartType: "NUMBER",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "SaleItem",
      dimensions: [],
      measures: ["SaleItem.revenue"],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
